import logo from "../../assets/canluxa-logo.png";

export default function Logo({ dark = false, compact = false }) {
  const iconSize = compact ? 30 : 38;
  const fontSize = compact ? 16 : 20;
  const subSize = compact ? 7 : 8.5;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 9, userSelect: "none", flexShrink: 0 }}>
      <div style={{
        width: iconSize, height: iconSize,
        borderRadius: Math.round(iconSize * .24),
        background: "rgba(255,255,255,.9)",
        display: "flex", alignItems: "center", justifyContent: "center",
        boxShadow: dark ? "none" : "0 4px 14px rgba(46,125,50,.28)",
        border: dark ? "1px solid rgba(255,255,255,.2)" : "none",
        backdropFilter: dark ? "blur(8px)" : "none",
        flexShrink: 0,
      }}>
        <img src={logo} alt="Canluxa" style={{ height: "40px" }} />
      </div>
      <div>
        <div style={{
          fontFamily: "'Playfair Display',serif",
          fontSize, fontWeight: 500,
          color: dark ? "rgba(255,255,255,.95)" : "var(--g900)",
          letterSpacing: ".4px", lineHeight: 1,
        }}>Canluxa</div>
        {!compact && (
          <div style={{
            fontSize: subSize, fontWeight: 700,
            letterSpacing: "1.8px", textTransform: "uppercase",
            color: dark ? "rgba(255,255,255,.38)" : "var(--mut)",
            marginTop: 2,
          }}>Valet Trash</div>
        )}
      </div>
    </div>
  );
}